import axios from 'axios';
import appConfig from 'config';
import { attachAxiosNProgress } from './attachAxiosNProgress';

const {
    api
} = appConfig;


const ShareOfAccountsApi = () => {
    const httpConfig = {
        baseURL: api.shareOfAccountsBaseUri
    };

    const instance = axios.create(httpConfig);
    attachAxiosNProgress(instance);

    // instance.interceptors.request.use(function (config) {
    //     const token = localStorage.getItem('api.tokenKey');
    //     config.headers.Authorization =  token ? `Bearer ${token}` : '';
    //     return config;
    // });

    return instance;
};


const HniAuthenticationApi = () => {
    const httpConfig = {
        baseURL: api.hniAuthBaseUri
    };

    const instance = axios.create(httpConfig);

    return instance;
};


const HniAuthApiWithProgress = () => {
    const instance = HniAuthenticationApi();
    attachAxiosNProgress(instance);

    instance.interceptors.request.use(function (config) {
        const token = localStorage.getItem('api.tokenKey');
        config.headers.Authorization =  token ? `Bearer ${token}` : '';
        return config;
    });

    return instance;
}


export {
    ShareOfAccountsApi,
    HniAuthenticationApi,
    HniAuthApiWithProgress
};
